export default "__VITE_ASSET__DazBtRSr__"